export default __webpack_public_path__ + "b14c3f5e0b0681847fdf292aca74cf75.png";